<template>
    <div :key="queueID">
        {{ getCallersCount }}
    </div>
</template>
<script>
import get from 'lodash/get'
import { ALL_QUEUE_ID } from '@/enum/redesignQueueDashboardStatistics'

export default {
    props: {
        queueID: {
            type: [ Number, String ],
            default: null
        },
        queueName: {
            type: String
        }
    },
    computed: {
        getQueueByID () {
            return this.$store.getters['queues/filterQueuesByIds']([ this.queueID ])
        },
        allQueueCalls () {
            return this.$store.getters['queues/allQueueCalls']
        },
        getCallersCount () {
            if (this.queueID === ALL_QUEUE_ID) {
                return this.allQueueCalls.length
            }

            const queueData = this.getQueueByID

            const calls = get(queueData, '[0].Calls', [])
            return calls.length
        }
    },
    watch: {
        getCallersCount: {
            immediate: true,
            handler (val) {
                if (this.queueID !== ALL_QUEUE_ID) {
                    this.$emit('getCallerCount', {
                        value: val,
                        queueID: this.queueID,
                        queueName: this.queueName
                    })
                }
            }
        }
    }
}
</script>
